
import { Container, Row, Col, Image, Modal } from 'react-bootstrap';
import um from '../../img/Manutencao/8.jpg';
import dois from '../../img/Manutencao/9.jpg';
import tres from '../../img/Manutencao/10.jpg';
import quatro from '../../img/Manutencao/4.jpg';
import cinco from '../../img/Manutencao/5.jpg';
import seis from '../../img/Manutencao/6.png';
import sete from '../../img/Manutencao/7.jpg';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import { AiOutlineClose } from 'react-icons/ai'; // Importando o ícone de fechar do React Icons
// Importando o CSS
import './Consultoria.css';

const Consultoria = () => {
  // Estado para o modal
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Função para abrir o modal com a imagem selecionada
  const handleShowModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setShowModal(true);
  };

  // Função para fechar o modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (
    <div>
      <Helmet>
  <html lang="pt-BR" />
  <title>Consultoria em tecnologia de informação e manutenção predial | Eficiência Operacional</title>
  <meta name="description" content="Melhore processos, reduza custos e implemente estratégias com nossa consultoria especializada." />
  <meta name="keywords" content="consultoria, melhoria de processos, eficiência" />
</Helmet>

 <section className="ti-section">
      <Container>
        <h2>Consultoria</h2>

        {/* Primeira linha (Texto + 4 imagens) */}
        <Row>
          {/* Primeira coluna: Texto */}
          <Col md={6} className="ti-text">
          <p style={{ fontSize: '18px', color: '#555' }}>
    Consultoria: Oferecemos estratégias personalizadas para impulsionar o 
    crescimento e a eficiência do seu negócio</p>
          </Col>

          {/* Segunda coluna: 4 Imagens */}
          <Col md={6} className="ti-image-col-4">
            <Image
              src={um}
              alt="Imagem 1"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(um)}
            />
            <Image
              src={dois}
              alt="Imagem 2"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(dois)}
            />
            <Image
              src={tres}
              alt="Imagem 3"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(tres)}
            />
            <Image
              src={quatro}
              alt="Imagem 4"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(quatro)}
            />
          </Col>
        </Row>

        {/* Segunda linha (2 imagens + 1 imagem grande) */}
        <Row className="ti-image-row">
          {/* Primeira coluna da segunda linha: 2 Imagens */}
          <Col md={7} className="ti-image-col-2">
            <Image
              src={cinco}
              alt="Imagem 5"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(cinco)}
            />
            <Image
              src={seis}
              alt="Imagem 6"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(seis)}
            />
          </Col>

          {/* Segunda coluna da segunda linha: Imagem grande */}
          <Col md={5} className="ti-image-col-large">
            <Image
              src={sete}
              alt="Imagem 7"
              fluid
              className="ti-image"
              onClick={() => handleShowModal(sete)}
            />
          </Col>
        </Row>
      </Container>

      {/* Modal para mostrar a imagem completa */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        className="ti-modal" // Classe personalizada para o modal
      >
        <Modal.Body>
          {/* Ícone de fechar usando o React Icons */}
          <AiOutlineClose 
            className="close-icon" 
            onClick={handleCloseModal} 
            title="Fechar" 
          />
          <Image
            src={selectedImage}
            alt="Imagem Grande"
            fluid
            className="ti-image" // Aplicando a classe de estilo para ajustar a imagem
          />
        </Modal.Body>
      </Modal>
    </section>
    </div>
   
  );
};

export default Consultoria;
